export default __webpack_public_path__ + "images/WST.c2c6d61.png";